<homey-lotteries-dialog-content
  singleTitle="Lottery number received!"
  multipleTitle="Lottery numbers received!"
  singleDescription="The drawing for this lottery has taken place. The organizer will now begin selecting applicants, starting with the lowest numbers, until all apartments are filled. This process can take a few months."
  multipleDescription="The drawings for these lotteries have taken place. The organizers will now begin selecting applicants, starting with the lowest numbers, until all apartments are filled. This process can take a few months."
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-lottery-list-item [apartment]="lottery" [openInPopup]="true">
      @let application = lottery.application;
      @if (application) {
        <p>Lottery number: {{ application.status === 'pending-selection' ? application.applicationNumber : '' }}</p>
      }
    </homey-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
